var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('bar-chart',{class:_vm.loading ? 'loading':'',staticStyle:{"width":"100%"},attrs:{"chartData":_vm.getChartData,"options":_vm.getOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }